import { defineAsyncComponent } from 'vue';

// Keep the registry synchronous and component identities stable while loading
// only icons that are actually rendered. Vue also resolves these during SSR.
export const asyncIcon = (importer) => defineAsyncComponent({
    loader: () => importer().then((module) => module.default ?? module),
    delay: 0,
});
